/* eslint-disable no-param-reassign */
/* eslint-disable import/prefer-default-export */
export function checkOverflow(el) {
  const curOverflow = el.style.overflow;

  if (!curOverflow || curOverflow === 'visible') el.style.overflow = 'hidden';

  const isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

  el.style.overflow = curOverflow;

  return isOverflowing;
}

export function getSiblings(e) {
  // for collecting siblings
  const siblings = [];
  // if no parent, return no sibling
  if (!e.parentNode) {
    return siblings;
  }
  // first child of the parent node
  let sibling = e.parentNode.firstChild;

  // collecting siblings
  while (sibling) {
    if (sibling.nodeType === 1 && sibling !== e) {
      siblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }
  return siblings;
}



export function getURLParametersValue(queryString) {
  const searchParams = new URLSearchParams(window.location.search);
  return searchParams.get(queryString);
}

export function updateUrlParameter(param, value) {
  const url = new URL(window.location.href);
  url.searchParams.set(param, value);
  window.location.href = url.toString();
}

export function getNextSiblings(element) {
  const nextSiblings = [];

  let sibling = element.nextSibling;

  while (sibling) {
    if (sibling.nodeType === 1 && sibling != element) {
      nextSiblings.push(sibling);
    }
    sibling = sibling.nextSibling;
  }

  return nextSiblings;
}

export function debounce(func, timeout = 300){
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => { func.apply(this, args); }, timeout);
  };
}

export function throttle(func, interval) {
  let isRunning = false;
  return function(...args) {
      if (!isRunning) {
          isRunning = true;
          func.apply(this, args);
          setTimeout(() => {
              isRunning = false;
          }, interval);
      }
  };
}